import { useState, useEffect } from 'react';
import { getAnnonces, publierAnnonce, marquerAnnonceLue, getLecturesAnnonce, modifierAnnonce, supprimerAnnonce, ouvrirPieceAnnonce } from '../api';

/*
 * Messages du coach ou du club : information descendante, on lit, on ne répond pas.
 * Les coachs et la direction publient ; chacun voit les messages qui lui sont adressés.
 */
const carte = { background: 'var(--card, #161b22)', border: '1px solid var(--border)', borderRadius: 12, padding: '14px 16px', marginBottom: 12 };
const champ = { width: '100%', background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 9, color: 'var(--text)', padding: '9px 11px', fontSize: 14, boxSizing: 'border-box' };
const petit = { fontSize: 12, color: 'var(--muted)' };
const dateCourte = d => { try { return new Date(d.replace(' ', 'T') + 'Z').toLocaleString('fr-FR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }); } catch { return d; } };
const taille = o => o < 1048576 ? `${Math.max(1, Math.round(o / 1024))} Ko` : `${(o / 1048576).toFixed(1)} Mo`;

function Redaction({ donnees, onPublie, onAnnule }) {
  const admin = !!donnees.peut_publier_club;
  const seule = donnees.equipes_publiables.length === 1 ? [donnees.equipes_publiables[0].id] : [];
  const [f, setF] = useState({ titre: '', texte: '', portee: 'equipes', equipes: seule, important: false, epingle: false, pieces: [] });
  const [envoi, setEnvoi] = useState(false); const [erreur, setErreur] = useState('');
  const basculerEquipe = id => setF(x => ({ ...x, equipes: x.equipes.includes(id) ? x.equipes.filter(e => e !== id) : [...x.equipes, id] }));
  const publier = async e => {
    e.preventDefault(); setErreur('');
    if (f.portee === 'equipes' && !f.equipes.length) return setErreur('Choisissez au moins une équipe');
    setEnvoi(true);
    try { await publierAnnonce(f); onPublie(); } catch (x) { setErreur(x.message); setEnvoi(false); }
  };
  return (
    <form onSubmit={publier} style={{ ...carte, borderColor: 'var(--accent)' }}>
      <div style={{ fontWeight: 700, marginBottom: 10 }}>Nouveau message</div>
      <input style={{ ...champ, marginBottom: 9 }} required maxLength={120} placeholder="Titre" value={f.titre} onChange={e => setF({ ...f, titre: e.target.value })} />
      <textarea style={{ ...champ, minHeight: 110, marginBottom: 9, fontFamily: 'inherit' }} maxLength={5000} placeholder="Votre message"
                value={f.texte} onChange={e => setF({ ...f, texte: e.target.value })} />
      <div style={{ ...petit, marginBottom: 6 }}>Destinataires</div>
      {admin && (
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 8 }}>
          {[['equipes', 'Équipes choisies'], ['club', 'Tout le club'], ['encadrement', 'Encadrement']].map(([v, l]) => (
            <button key={v} type="button" aria-pressed={f.portee === v} onClick={() => setF({ ...f, portee: v })}
                    style={{ padding: '6px 10px', borderRadius: 8, fontSize: 12.5, cursor: 'pointer', color: 'var(--text)',
                             background: f.portee === v ? 'rgba(230,57,70,.14)' : 'transparent', border: `1px solid ${f.portee === v ? 'var(--accent)' : 'var(--border)'}` }}>{l}</button>))}
        </div>)}
      {f.portee === 'equipes' && (
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 10 }}>
          {donnees.equipes_publiables.map(e => (
            <label key={e.id} style={{ display: 'flex', gap: 6, alignItems: 'center', fontSize: 13, cursor: 'pointer' }}>
              <input type="checkbox" checked={f.equipes.includes(e.id)} onChange={() => basculerEquipe(e.id)} /> {e.nom}</label>))}
        </div>)}
      <label style={{ display: 'flex', gap: 7, alignItems: 'center', fontSize: 13, marginBottom: 6, cursor: 'pointer' }}>
        <input type="checkbox" checked={f.important} onChange={e => setF({ ...f, important: e.target.checked })} /> ❗ Important — envoyé aussi par email</label>
      <label style={{ display: 'flex', gap: 7, alignItems: 'center', fontSize: 13, marginBottom: 10, cursor: 'pointer' }}>
        <input type="checkbox" checked={f.epingle} onChange={e => setF({ ...f, epingle: e.target.checked })} /> 📌 Épingler en tête</label>
      <label style={{ ...petit, display: 'block', marginBottom: 6 }}>Pièces jointes — PDF ou photos, 5 au plus, 5 Mo chacune
        <input type="file" multiple accept="application/pdf,image/jpeg,image/png,image/webp" style={{ display: 'block', marginTop: 6 }}
               onChange={e => setF({ ...f, pieces: [...e.target.files].slice(0, 5) })} /></label>
      {erreur && <div style={{ color: 'var(--danger)', fontSize: 13, margin: '8px 0' }}>{erreur}</div>}
      <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
        <button className="btn btn-primary" disabled={envoi}>{envoi ? 'Publication…' : 'Publier'}</button>
        <button type="button" className="btn btn-secondary" onClick={onAnnule}>Annuler</button>
      </div>
    </form>);
}

function Message({ a, onLu, onChange }) {
  const [ouvert, setOuvert] = useState(false);
  const [lecteurs, setLecteurs] = useState(null);
  const nouveau = a.destinataire && !a.lu;
  const ouvrir = () => {
    setOuvert(o => !o);
    if (nouveau) marquerAnnonceLue(a.id).then(onLu).catch(() => {});
  };
  return (
    <div style={{ ...carte, borderColor: nouveau ? 'var(--accent)' : 'var(--border)' }}>
      <button type="button" onClick={ouvrir} aria-expanded={ouvert}
              style={{ all: 'unset', cursor: 'pointer', display: 'block', width: '100%' }}>
        <div style={{ display: 'flex', gap: 6, alignItems: 'baseline', flexWrap: 'wrap' }}>
          {a.epingle && <span title="Épinglé">📌</span>}
          {a.important && <span style={{ color: 'var(--danger)', fontSize: 11, fontWeight: 800, textTransform: 'uppercase' }}>Important</span>}
          {nouveau && <span style={{ background: 'var(--accent)', color: '#fff', fontSize: 10, fontWeight: 800, borderRadius: 5, padding: '1px 6px' }}>NOUVEAU</span>}
          <span style={{ fontWeight: 700, fontSize: 15 }}>{a.titre}</span>
        </div>
        <div style={{ ...petit, marginTop: 3 }}>{a.auteur} · {a.destination} · {dateCourte(a.created_at)}{a.pieces.length ? ` · 📎 ${a.pieces.length}` : ''}</div>
        {!ouvert && a.texte && <div style={{ fontSize: 13.5, marginTop: 6, color: 'var(--muted)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{a.texte}</div>}
      </button>
      {ouvert && (
        <>
          {a.texte && <div style={{ fontSize: 14, marginTop: 10, whiteSpace: 'pre-line', lineHeight: 1.55 }}>{a.texte}</div>}
          {a.pieces.length > 0 && (
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 10 }}>
              {a.pieces.map(p => (
                <button key={p.id} type="button" className="btn btn-secondary" style={{ width: 'auto', padding: '6px 10px', fontSize: 12.5 }}
                        onClick={() => ouvrirPieceAnnonce(p.id).catch(() => {})}>
                  {p.type === 'application/pdf' ? '📄' : '🖼️'} {p.nom} <span style={petit}>({taille(p.taille)})</span></button>))}
            </div>)}
        </>)}
      {a.gerer && (
        <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap', marginTop: 10, ...petit }}>
          {a.lecture && <button type="button" style={{ all: 'unset', cursor: 'pointer', textDecoration: 'underline' }}
                                onClick={() => lecteurs ? setLecteurs(null) : getLecturesAnnonce(a.id).then(r => setLecteurs(r.lecteurs))}>
            👁️ Lu par {a.lecture.lus} sur {a.lecture.total}</button>}
          <button type="button" style={{ all: 'unset', cursor: 'pointer', textDecoration: 'underline' }}
                  onClick={() => modifierAnnonce(a.id, { epingle: !a.epingle }).then(onChange)}>{a.epingle ? 'Désépingler' : 'Épingler'}</button>
          <button type="button" style={{ all: 'unset', cursor: 'pointer', textDecoration: 'underline', color: 'var(--danger)' }}
                  onClick={() => { if (window.confirm('Supprimer ce message et ses pièces jointes ?')) supprimerAnnonce(a.id).then(onChange); }}>Supprimer</button>
        </div>)}
      {lecteurs && (
        <div style={{ marginTop: 8, fontSize: 12.5, lineHeight: 1.6 }}>
          {lecteurs.map((l, i) => <div key={i} style={{ color: l.lu_le ? 'var(--muted)' : 'var(--text)' }}>{l.lu_le ? '✓' : '○'} {l.nom}{l.lu_le ? ` — ${dateCourte(l.lu_le)}` : ' — pas encore lu'}</div>)}
        </div>)}
    </div>);
}

export default function MessagesPage({ onLu }) {
  const [d, setD] = useState(null); const [saison, setSaison] = useState(null);
  const [redaction, setRedaction] = useState(false); const [erreur, setErreur] = useState('');
  const charger = s => getAnnonces(s).then(r => { setD(r); setSaison(r.saison); }).catch(e => setErreur(e.message));
  useEffect(() => { charger(); }, []);
  if (erreur) return <div className="page"><div style={carte}>{erreur}</div></div>;
  if (!d) return <div className="page" style={{ color: 'var(--muted)', padding: 20 }}>Chargement…</div>;
  const recharger = () => { charger(saison); onLu?.(); };
  return (
    <div className="page">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
        <div style={{ fontSize: 20, fontWeight: 800 }}>📣 Messages</div>
        <div style={{ display: 'flex', gap: 8 }}>
          {d.saisons.length > 1 && (
            <select value={saison} onChange={e => charger(e.target.value)} aria-label="Saison" style={{ ...champ, width: 'auto', padding: '6px 8px' }}>
              {d.saisons.map(s => <option key={s} value={s}>{s}</option>)}</select>)}
          {d.peut_publier && !redaction && <button className="btn btn-primary" style={{ width: 'auto' }} onClick={() => setRedaction(true)}>✏️ Nouveau message</button>}
        </div>
      </div>
      {redaction && <Redaction donnees={d}
                               onPublie={() => { setRedaction(false); recharger(); }} onAnnule={() => setRedaction(false)} />}
      {d.annonces.length === 0 && !redaction && (
        <div style={{ ...carte, color: 'var(--muted)', fontSize: 14 }}>
          Aucun message pour le moment. Les informations de votre coach et de votre club apparaîtront ici.</div>)}
      {d.annonces.map(a => <Message key={a.id} a={a} onLu={onLu} onChange={recharger} />)}
    </div>);
}
